import api from './api';

/**
 * 企业微信服务
 */
const weworkService = {
  /**
   * 获取企业微信员工列表
   * @param {Object} params 查询参数
   * @param {string} params.keyword 搜索关键词
   * @param {number} params.departmentId 部门ID
   * @param {number} params.page 页码
   * @param {number} params.size 每页大小
   * @returns {Promise<Object>} 包含员工列表的响应
   */
  getEmployees: async (params = {}) => {
    try {
      const response = await api.get('/wework/employees', { params });
      return response.data;
    } catch (error) {
      console.error('获取企业微信员工列表失败:', error);
      throw error;
    }
  },

  /**
   * 获取所有企业微信员工(不分页)
   * @returns {Promise<Array>} 员工列表
   */
  getAllEmployees: async () => {
    try {
      const response = await api.get('/wework/employees', { 
        params: { 
          size: 999 // 获取大量记录
        } 
      });
      return response.data.content || [];
    } catch (error) {
      console.error('获取所有企业微信员工失败:', error);
      throw error;
    }
  },

  /**
   * 获取企业微信客户群列表
   * @param {Object} params 查询参数
   * @param {string} params.keyword 搜索关键词
   * @param {number} params.page 页码
   * @param {number} params.size 每页大小
   * @returns {Promise<Object>} 包含群组列表的响应
   */
  getGroups: async (params = {}) => {
    try {
      const response = await api.get('/groups', { params });
      
      // 过滤出企微群组
      if (response.data && response.data.content) {
        const weworkGroups = response.data.content.filter(group => 
          group.source === 'WEWORK' && group.weworkGroup
        );
        return {
          ...response.data,
          content: weworkGroups
        };
      }
      
      return response.data;
    } catch (error) {
      console.error('获取企业微信客户群列表失败:', error);
      throw error;
    }
  },

  /**
   * 获取所有企业微信客户群(不分页)
   * @returns {Promise<Array>} 群组列表
   */
  getAllGroups: async () => {
    try {
      const response = await api.get('/groups', { 
        params: { 
          size: 999 // 获取大量记录
        } 
      });
      
      let allGroups = response.data.content || response.data || [];
      
      // 过滤出企微群组，并转换数据格式
      const weworkGroups = allGroups
        .filter(group => group.source === 'WEWORK' && group.weworkGroup)
        .map(group => {
          // 获取群组名称，优先使用 group.name，然后是 weworkGroup.name，最后是默认值
          let groupName = '';
          
          // 先检查 group.name
          if (group.name && group.name.trim() !== '') {
            groupName = group.name.trim();
          }
          // 如果 group.name 为空，检查 weworkGroup.name
          else if (group.weworkGroup && group.weworkGroup.name && group.weworkGroup.name.trim() !== '') {
            groupName = group.weworkGroup.name.trim();
          }
          // 都为空则使用默认值
          else {
            groupName = '未知群聊';
          }
          
          return {
            id: group.id,
            chatId: group.sourceId, // sourceId 就是企微的 chatId
            owner: group.weworkGroup && group.weworkGroup.owner,
            ownerName: group.ownerName,
            memberCount: group.memberCount,
            status: group.status,
            createTime: group.weworkGroup && group.weworkGroup.createTime,
            ...group.weworkGroup, // 包含完整的企微群信息
            name: groupName // 确保 name 不被覆盖，放在最后
          };
        });
        
      console.log('获取到企微群组数量:', weworkGroups.length);
      return weworkGroups;
    } catch (error) {
      console.error('获取所有企业微信客户群失败:', error);
      throw error;
    }
  }
};

export default weworkService; 